import { LevelType } from 'data/types';
import { isConditionedSpace } from './conditioned-spaces';

export type StructureStats = {
  levels: number;
  rooms: number;
  windows: number;
  doors: number;
};

export function getStructureStats(structure: LevelType[]): StructureStats {
  let rooms = 0;
  let windows = 0;
  let doors = 0;

  structure.forEach((level) => {
    level.sections.forEach((section) => {
      section.spaces.forEach((space) => {
        if (isConditionedSpace(space)) {
          rooms += 1;
        }
        const { sizingAttributes } = space;
        if (sizingAttributes) {
          sizingAttributes.aboveGradeWalls.forEach((wall) => {
            windows += wall.verticalGlass?.length ?? 0;
            doors += wall.solidDoors?.length ?? 0;
          });
          sizingAttributes.belowGradeWalls.forEach((wall) => {
            windows += wall.verticalGlass?.length ?? 0;
          });
        }
      });
    });
  });

  return { levels: structure.length, rooms, windows, doors };
}
